import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import { omit } from 'lodash'
import Dialog from 'material-ui/Dialog'
import ReactModal from 'react-modal'
import FlatButton from 'material-ui/FlatButton'
import DropDownMenu from 'material-ui/DropDownMenu'
import MenuItem from 'material-ui/MenuItem'
import { toolbarStyles, themeColors } from '../../styles/theme'
import breakpoints from '../../styles/breakpoints'
import MediaQuery from 'react-responsive'
import { getWorlds } from '../../selectors'

const omitPadding = style =>
  omit(style, ['paddingLeft', 'paddingRight', 'padding'])

const styles = {
  titleContainer: {
    backgroundColor: themeColors.lightBackground,
    paddingTop: '10px',
    paddingBottom: '10px',
  },
  title: {
    margin: '0px',
    paddingLeft: '24px',
    paddingRight: '24px',
  },
  dropdownsContainer: {
    display: 'flex',
    flexDirection: 'column',
  },
  dropdownsContainerSmall: {
    display: 'flex',
    flexDirection: 'row',
  },
  dropodownLabel: omitPadding({
    ...toolbarStyles.labelStyle,
    ...toolbarStyles.activeLabel,
  }),
  dropodownLabelSmall: omitPadding({
    ...toolbarStyles.labelStyleSmall,
    ...toolbarStyles.activeLabel,
  }),
}

class ItemsModal extends PureComponent {
  state = {
    world: null,
    category: null,
  }

  chooseWorld = (e, i, value) => this.setState({ world: value, category: null })

  chooseCategory = (e, i, value) => this.setState({ category: value })

  getCategories = () => {
    if (this.state.world === null) {
      return null
    }
    return this.props.categoriesByWorld[this.state.world.slug].map(
      catSlug => this.props.categoriesBySlug[catSlug]
    )
  }

  render() {
    const { children, open, onRequestClose, worlds } = this.props
    const { world, category } = this.state
    const categories = this.getCategories()

    const actions = [
      <FlatButton label="Annulla" primary={true} onClick={onRequestClose} />,
      <FlatButton
        label="Ok"
        primary={true}
        keyboardFocused={true}
        onClick={onRequestClose}
      />,
    ]

    const title = (
      <MediaQuery minWidth={breakpoints.md}>
        {matches => (
          <div style={styles.titleContainer}>
            <h3 style={styles.title}>Aggiungi allo scambio</h3>
            <div
              style={
                matches
                  ? styles.dropdownsContainerSmall
                  : styles.dropdownsContainer
              }>
              {worlds && (
                <DropDownMenu
                  onChange={this.chooseWorld}
                  value={world}
                  iconStyle={toolbarStyles.iconStyle}
                  labelStyle={
                    matches ? styles.dropodownLabel : styles.dropodownLabelSmall
                  }>
                  <MenuItem value={null} primaryText="Tutti i mondi" />
                  {worlds.map(world => (
                    <MenuItem
                      key={world.id}
                      value={world}
                      primaryText={world.nome}
                    />
                  ))}
                </DropDownMenu>
              )}
              {categories && (
                <DropDownMenu
                  value={category}
                  onChange={this.chooseCategory}
                  iconStyle={toolbarStyles.iconStyle}
                  labelStyle={
                    matches ? styles.dropodownLabel : styles.dropodownLabelSmall
                  }>
                  <MenuItem value={null} primaryText="Tutte le categorie" />
                  {categories.map(category => (
                    <MenuItem
                      key={category.id}
                      value={category}
                      primaryText={category.nome}
                    />
                  ))}
                </DropDownMenu>
              )}
            </div>
          </div>
        )}
      </MediaQuery>
    )

    // See https://github.com/callemall/material-ui/issues/3553#issuecomment-253830636
    // for fullscreen strategy...
    // but the mine is much good ;)
    return (
      <Dialog
        repositionOnUpdate={false}
        autoDetectWindowHeight={false}
        className="swaps-items-modal"
        contentClassName="swaps-items-modal-content"
        paperClassName="swaps-items-modal-paper"
        bodyClassName="swaps-items-modal-body"
        contentStyle={{ width: '100%', transform: 'translate(0, 0)' }}
        bodyStyle={{ padding: 0 }}
        style={{ paddingTop: 0 }}
        title={title}
        actions={actions}
        autoScrollBodyContent={true}
        modal={false}
        open={open}
        onRequestClose={onRequestClose}>
        {React.Children.map(children, child =>
          React.cloneElement(child, { world, category })
        )}
      </Dialog>
    )
  }
}

const mapStateToProps = state => {
  const worlds = getWorlds(state)
  return {
    worlds,
    categoriesByWorld: state.categoriesAndWorlds.categoriesByWorld,
    categoriesBySlug: state.categoriesAndWorlds.categoriesBySlug,
  }
}

export default connect(mapStateToProps)(ItemsModal)



// WEBPACK FOOTER //
// ./src/common/Swap/ItemsModal.js